import alumniImage from "../../images/alumni.png";
export const AlumniContributionJson = [
    {
        id: 2,
        title: "Alumni Contribution",
        imgSrc: alumniImage, // Replace with the actual image source
        thankingMessage: "Thank you for being a key supporter of our mission. Your contributions help us enhance the journey of our senior colleagues and strengthen our college ."
    },
];
